export const ERROR_MESSAGE_NOT_VERIFY_READ = 20006001
export const ERROR_MESSAGE_ALREADY_VERIFIED = 20006003
// LexNET: "No ha llegado el identificador de sesion correcto al servidor, o bien ésta ha sido cancelada"
export const ERROR_LEXNET_SESSION_EXPIRED = 20000002
export const LEXNET_MAX_MAIN_FILE_SIZE = 15000000
export const LEXNET_MAX_TOTAL_FILE_SIZE = 100000000
